import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { TailwindColors } from "@vc-workspace/utils-colors";
import { Typography } from "@vc-workspace/utils-typography";
import { imageStyles, ratingContainer, viewMoreImageContainer, viewMoreImageOverlay } from "./review-list-item.module.style";
import { getFormattedDate } from "@vc-workspace/utils-formatters";
import { PRODUCT_NAME_CHAR_LIMIT, ReviewTemplateEntryTypes, SourceKey, SourceNameKey } from "@vc-workspace/utils-constants";
import { useState } from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
var DESKTOP_REVIEW_DESC_LIMIT = 350;
var MOBILE_REVIEW_DESC_LIMIT = 150;
var IMAGE_DISPLAY_COUNT = 3;
export function ReviewListItem(props) {
  var _freetextReviewEntry$, _imageReviewEntry$ima;

  var _useState = useState(false),
      showFullDesc = _useState[0],
      toggleFullDesc = _useState[1];

  var _useState2 = useState(0),
      imageIndex = _useState2[0],
      setImageIndex = _useState2[1];

  var _useState3 = useState(false),
      viewgallery = _useState3[0],
      toggleGallery = _useState3[1];

  var onImageCardClick = function onImageCardClick(index) {
    setImageIndex(index);
    toggleGallery(true);
  };

  var freetextReviewEntry = props.reviewDetails.entries.filter(function (item) {
    return item.entryType === ReviewTemplateEntryTypes.FREE_TEXT;
  })[0];
  var imageReviewEntry = props.reviewDetails.entries.filter(function (item) {
    return item.entryType === ReviewTemplateEntryTypes.IMAGE_UPLOAD;
  })[0];
  var displayDesc = "";

  if (freetextReviewEntry && (_freetextReviewEntry$ = freetextReviewEntry.textValue) !== null && _freetextReviewEntry$ !== void 0 && _freetextReviewEntry$.trim()) {
    displayDesc = freetextReviewEntry.textValue;
  }

  if (!showFullDesc) {
    displayDesc = displayDesc.slice(0, props.context.isMobileView ? MOBILE_REVIEW_DESC_LIMIT : DESKTOP_REVIEW_DESC_LIMIT);
  }

  var imageUrlList = [];

  if (imageReviewEntry) {
    imageUrlList = imageReviewEntry.images.map(function (image) {
      return image.url;
    });
  }

  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      className: "py-4 ".concat(props.wrapperClassName),
      children: [_jsxs("div", {
        className: "flex items-center justify-between",
        children: [_jsxs("div", {
          className: "flex items-center",
          children: [_jsxs(Typography, {
            type: props.context.isMobileView ? "Body1" : "SubHeading1",
            color: TailwindColors.amber[500],
            custom_style: ratingContainer,
            semi_bold: true,
            children: [props.reviewDetails.primaryEntryRating, " ", _jsx("img", {
              src: "/_mp-images/review_display_star.svg",
              className: "ml-1"
            })]
          }), _jsx(Typography, {
            type: props.context.isMobileView ? "Body1" : "SubHeading1",
            color: TailwindColors.grey[800],
            className: "ml-3",
            semi_bold: true,
            children: props.reviewDetails.reviewerName
          })]
        }), _jsx(Typography, {
          type: props.context.isMobileView ? "Body2" : "Body1",
          color: TailwindColors.grey[500],
          children: getFormattedDate(props.reviewDetails.created_at)
        })]
      }), displayDesc ? _jsx("div", {
        onClick: function onClick() {
          return toggleFullDesc(true);
        },
        className: "cursor-pointer",
        children: _jsxs(Typography, {
          type: "Body1",
          color: TailwindColors.grey[600],
          className: "pt-5 md:pt-1.5",
          regular: true,
          children: [displayDesc, !showFullDesc && freetextReviewEntry.textValue.length > displayDesc.length ? _jsx(Typography, {
            type: "Body2",
            color: TailwindColors.grey[700],
            className: "text-right",
            semi_bold: true,
            inline: true,
            children: "\xA0...read more"
          }) : null]
        })
      }) : null, imageReviewEntry && (_imageReviewEntry$ima = imageReviewEntry.images) !== null && _imageReviewEntry$ima !== void 0 && _imageReviewEntry$ima.length ? _jsxs("div", {
        className: "flex items-center pt-3 md:pt-5",
        children: [imageReviewEntry.images.slice(0, IMAGE_DISPLAY_COUNT).map(function (image, index) {
          return _jsx("img", {
            src: image.url,
            css: imageStyles,
            alt: "",
            className: "cursor-pointer",
            onClick: function onClick() {
              return onImageCardClick(index);
            }
          }, image.document);
        }), imageReviewEntry.images.length > IMAGE_DISPLAY_COUNT ? _jsxs("div", {
          css: viewMoreImageContainer,
          onClick: function onClick() {
            return onImageCardClick(IMAGE_DISPLAY_COUNT);
          },
          children: [_jsx("img", {
            src: imageReviewEntry.images[IMAGE_DISPLAY_COUNT].url,
            css: imageStyles,
            alt: "",
            className: "cursor-pointer"
          }), _jsxs(Typography, {
            type: props.context.isMobileView ? "Body2" : "Body1",
            color: TailwindColors.white,
            custom_style: viewMoreImageOverlay,
            semi_bold: true,
            children: ["+ ", imageReviewEntry.images.length - IMAGE_DISPLAY_COUNT]
          })]
        }, imageReviewEntry.images[IMAGE_DISPLAY_COUNT].document) : null]
      }) : null, props.showReviewEntityDetails && props.reviewDetails.itemOrderUsId ? _jsxs("div", {
        className: "flex items-center mt-3",
        children: [_jsx(Typography, {
          type: "Body1",
          color: TailwindColors.grey[700],
          children: "Item bought:"
        }), _jsx("a", {
          href: "/".concat(props.reviewDetails.itemSlug, "/").concat(props.reviewDetails.itemUsId, "?").concat(SourceKey, "=").concat(props.sourceType, "&").concat(SourceNameKey, "=").concat(props.sourceName),
          target: "_blank",
          rel: "noreferrer",
          children: _jsxs(Typography, {
            type: "Body1",
            color: TailwindColors.grey[700],
            className: "pl-1",
            regular: true,
            underline: true,
            children: [props.reviewDetails.itemName.slice(0, PRODUCT_NAME_CHAR_LIMIT), props.reviewDetails.itemName.length >= PRODUCT_NAME_CHAR_LIMIT ? "..." : ""]
          })
        })]
      }) : null]
    }), viewgallery ? _jsx(Lightbox, {
      mainSrc: imageUrlList[imageIndex],
      nextSrc: imageUrlList[(imageIndex + 1) % imageUrlList.length],
      prevSrc: imageUrlList[(imageIndex + imageUrlList.length - 1) % imageUrlList.length],
      onCloseRequest: function onCloseRequest() {
        return toggleGallery(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setImageIndex((imageIndex + imageUrlList.length - 1) % imageUrlList.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setImageIndex((imageIndex + 1) % imageUrlList.length);
      }
    }) : null]
  });
}
export default ReviewListItem;